import { useOutletContext } from "react-router-dom";

import Unauthorized from "../../ui/components/Unauthorized/Unauthorized";

import useHasRight from "../../authorization/hooks/useHasRight";

import AgreementTemplatesView from "../views/AgreementTemplatesView/AgreementTemplatesView";

export default function AgreementTemplates() {
	const { organization } = useOutletContext();

	const hasRight = useHasRight();

	if (!hasRight("agreements.view")) {
		return <Unauthorized />;
	}

	return <AgreementTemplatesView firstPartyId={organization.id} />;
}
